import type { GlobalSearchResultsData } from '../types';
import GlobalSearchHeader from './GlobalSearchHeader';
import GlobalSearchProductCard from './GlobalSearchProductCard';
import GlobalSearchResultsBlock from './GlobalSearchResultsBlock';

interface GlobalSearchProductsProps {
    isMediaDiscountVoucher: boolean;
    searchResults: GlobalSearchResultsData;
    searchTerm: string;
    onSearchProductClick: (eanId: number, index: number, productId: number, variantId: number) => void;
}

function GlobalSearchProducts({
    isMediaDiscountVoucher, searchResults, searchTerm, onSearchProductClick,
}: GlobalSearchProductsProps) {
    return (
        <GlobalSearchResultsBlock>
            <GlobalSearchHeader title={searchResults?.products?.title} />
            {searchResults?.products?.items?.map((item, index) => (
                <GlobalSearchProductCard
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    index={index}
                    isMediaDiscountVoucher={isMediaDiscountVoucher}
                    product={item}
                    searchTerm={searchTerm}
                    onSearchProductClick={onSearchProductClick}
                />
            ))}
        </GlobalSearchResultsBlock>
    );
}

export default GlobalSearchProducts;
